// TSS vite/03 §"Query keys".

export const medicalKeys = {
    all: ['medical-events'],
    list: (filters) => ['medical-events', 'list', filters],
};
